import { useCallback } from "react";
import { CustomerTemplate } from "@/components/CustomerTemplateManager";
import { OrderStatus } from "@/components/OrderControls";
import { BatchActionToolbar } from "@/components/BatchActionToolbar";
import { BatchOrderSummary } from "@/components/BatchOrderSummary";
import { OrderDataTable } from "@/components/OrderDataTable";

interface BatchModeViewProps {
  customers: CustomerTemplate[];
  selectedCustomerIds: string[];
  onSelectionChange: (ids: string[]) => void;
  onBatchStatusChange: (status: OrderStatus) => void;
  openMoveOrderDateDialog: (modeOrDate?: 'single' | 'bulk' | Date, presetDate?: Date) => void;
  isProcessing: boolean;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  keepFilter: string;
  onKeepFilterChange: (status: string) => void;
  onDownloadExcel: () => void;
  onViewDetails: (customerId: string) => void;
  onShowMemo: (customer: CustomerTemplate) => void;
  onKeepToggle: (customerId: string, currentKeepStatus: boolean) => void;
  sortOption: string;
  onSortChange: (value: string) => void;
  // 스펙 D10: 계좌 연동(linked) 셀러만 '부분 입금'을 선택할 수 있다(Home의 selectableOrderStatuses 결과 주입).
  statusOptions: OrderStatus[];
}

export function BatchModeView({
  customers,
  selectedCustomerIds,
  onSelectionChange,
  onBatchStatusChange,
  openMoveOrderDateDialog,
  isProcessing,
  statusFilter,
  onStatusFilterChange,
  keepFilter,
  onKeepFilterChange,
  onDownloadExcel,
  onViewDetails,
  onShowMemo,
  onKeepToggle,
  sortOption,
  onSortChange,
  statusOptions,
}: BatchModeViewProps) {
  // Stable closure so the memo() barrier on BatchActionToolbar holds.
  const handleBatchDateChange = useCallback(
    () => openMoveOrderDateDialog('bulk'),
    [openMoveOrderDateDialog],
  );

  return (
    <div className="p-4 sm:p-6 space-y-4">
      <BatchActionToolbar
        selectedCount={selectedCustomerIds.length}
        onBatchStatusChange={onBatchStatusChange}
        onBatchDateChange={handleBatchDateChange}
        isProcessing={isProcessing}
        statusFilter={statusFilter}
        onStatusFilterChange={onStatusFilterChange}
        keepFilter={keepFilter}
        onKeepFilterChange={onKeepFilterChange}
        onDownloadExcel={onDownloadExcel}
        statusOptions={statusOptions}
      />
      <OrderDataTable
        customers={customers}
        selectedCustomerIds={selectedCustomerIds}
        onSelectionChange={onSelectionChange}
        onViewDetails={onViewDetails}
        onShowMemo={onShowMemo}
        onKeepToggle={onKeepToggle}
        sortOption={sortOption}
        onSortChange={onSortChange}
      />
      <BatchOrderSummary customers={customers} />
    </div>
  );
}
